import React, { useContext, useEffect } from 'react'
import { observer } from 'mobx-react'
import './index.scss'
import { CLEAR_WORK_DRAFT } from '@Const/work-registration-forms'
import { StoresContext } from '@App/contexts'
import { FetchType } from '@App/kit/components/WorkItemV2/fetch-type-enum'
import RootStore from '@App/stores/root-store'
import HistoryExtendedWorkItem from '@Components/WorkItemV2/History/HistoryExtendedWorkItem'

const ClaimSubmissionStep = () => {
    const { workStore, claimToolStore } = useContext<RootStore>(StoresContext)

    useEffect(() => {
        workStore.setWizardStepValidation(true)

        return () => {
            workStore.destroyViewWork()
            workStore.setWorkDraftToLocal(CLEAR_WORK_DRAFT)
            workStore.setWizardStepValidation(false)
            claimToolStore.resetClaimingToolWizard()
        }
    }, [])

    return (
        <div className="claim-submission-step">
            <h5>Submit</h5>
            <div className="description">
                Your claim has been submitted. You can review your submission in Registration History. Please note:
                newly submitted claims can take 1-3 weeks to be processed.
            </div>

            <div className="history-item">
                {workStore.workDraftLocal && (
                    <HistoryExtendedWorkItem
                        work={workStore.workDraftLocal}
                        fetchType={FetchType.MLC}
                        getId={() => ''}
                    />
                )}
            </div>
        </div>
    )
}

export default observer(ClaimSubmissionStep)
